<h1 mat-dialog-title>{{ data?.title }}</h1>
<div mat-dialog-content>
    <mat-form-field>
        <mat-label>Bitte ein Zeitraum eingeben</mat-label>
        <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [formControl]="vonCtrl" placeholder="Von" />
            <input matEndDate [formControl]="bisCtrl" placeholder="Bis" />
        </mat-date-range-input>
        <mat-hint>dd.MM.yyyy – dd.MM.yyyy</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Abbrechen</button>
    <button mat-flat-button [disabled]="disabled()" (click)="onSubmit()" color="accent">&Uuml;bernehmen</button>
</div>
